<template>
	<div class="container audit-card mx-auto">
		<div class="row">
			<div class="col-12">
				<h5 v-if="type === 'good'" class="font-weight-bold">3 Things done well</h5>
				<h5 v-else class="font-weight-bold">3 Things needs improving</h5>
			</div>
		</div>
		<div class="row" v-for="(comment, index) in comments">
			<div class="col-12">
				<h6>{{index+1}}. {{comment.comment}}</h6>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props:[
			'comments',
			'type'
		],
	}
</script>
